import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get} from 'bukku/shared/ApiService';

// Read all
export function* readAllRequest() {
    yield takeEvery(actions.PLAN_READ_ALL_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/plans', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PLAN_READ_ALL_SUCCESS,
                plans: data.plans,
            });
        }
        catch (error) {
            yield put({
                type: actions.PLAN_READ_ALL_FAILURE,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readAllSuccess() {
    yield takeEvery(actions.PLAN_READ_ALL_SUCCESS, () => {});
}
export function* readAllFailure() {
    yield takeEvery(actions.PLAN_READ_ALL_FAILURE, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readAllRequest),
        fork(readAllSuccess),
        fork(readAllFailure),
    ]);
}
